import { useEffect, useState, useCallback } from "react";
import { api, CITIES_FALLBACK } from "./api";

// Fetches the cities list from /api/cities (names only). Falls back to static list on error.
export function useCities() {
    const [cities, setCities] = useState(CITIES_FALLBACK);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/cities");
            const names = (data || []).map((c) => c.name);
            if (names.length) setCities(names);
        } catch {
            /* keep fallback */
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return { cities, loading, refresh };
}
